import {
  generic,
  deviceConfiguration,
  login,
  logout,
  mediaPermissions,
  meeting,
  screenShare,
  browserCheck,
  liveStreaming,
  tooltip,
  notificationMessage,
  layout,
  recording,
  userTabCmp,
  accountCmp,
  regenPinsTabCmp,
  liveStreamingCmp,
  errors,
  success,
  roster,
  chat,
  meetingType,
  meetingPrivacy,
  supportMenu
} from './l10n.en';
import { LocaleMessages } from './types';


const en: LocaleMessages = Object.assign({},
  generic,
  deviceConfiguration,
  login,
  logout,
  mediaPermissions,
  meeting,
  screenShare,
  browserCheck,
  liveStreaming,
  tooltip,
  notificationMessage,
  layout,
  recording,
  userTabCmp,
  accountCmp,
  regenPinsTabCmp,
  liveStreamingCmp,
  errors,
  success,
  roster,
  chat,
  meetingType,
  meetingPrivacy,
  supportMenu
);


export default en;
